import React from "react"
import "./index.scss"

export default function StatistcsRow({ component }) {
  const stats = component.statistics

  return (
    <div className="statistics-section" data-datocms-noindex>
      <div className="container">
        <div className="row">
          {
            stats.map(stat => (
              <div className="stat" key={stat.description}>
                <div className="stat__number">
                  <h3 className="oblique highlight red">{stat.number}</h3>
                </div>

                <div className="stat__text">
                  <h6 className="oblique">{stat.description}</h6>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
